import { lazy } from "react";
import { MODULE_IDS } from "../../constants/enums";
import Loadable from "../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../router/AuthorizedRoute";
import { app_navbar_routes } from "../../constants/app-navbar-routes";

const PurchaseInvoiceTable = Loadable(
  lazy(() =>
    import("./PurchaseInvoiceTable").then(({ PurchaseInvoiceTable }) => ({
      default: PurchaseInvoiceTable,
    })),
  ),
);

const ManageSinglePurchaseInvoice = Loadable(
  lazy(() =>
    import("./ManageSinglePurchaseInvoice").then(
      ({ ManageSinglePurchaseInvoice }) => ({
        default: ManageSinglePurchaseInvoice,
      }),
    ),
  ),
);

export const purchaseInvoiceRoutes = [
  {
    path: app_navbar_routes.app.purchaseInvoice.purchaseInvoice,
    exact: true,
    element: (
      <AuthorizedRoute moduleIds={[MODULE_IDS.PURCHASE_INVOICE]}>
        <PurchaseInvoiceTable />
      </AuthorizedRoute>
    ),
  },
  {
    path: app_navbar_routes.app.approvals.purchase_invoice,
    exact: true,
    element: (
      <AuthorizedRoute moduleIds={[MODULE_IDS.APPROVAL_PURCHASE_INVOICE]}>
        <PurchaseInvoiceTable module="APPROVAL" />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${app_navbar_routes.app.purchaseInvoice.purchaseInvoice}/manage`,
    exact: true,
    element: (
      <AuthorizedRoute moduleIds={[MODULE_IDS.PURCHASE_INVOICE]}>
        <ManageSinglePurchaseInvoice />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${app_navbar_routes.app.purchaseInvoice.purchaseInvoice}/manage/:uuid`,
    exact: true,
    element: (
      <AuthorizedRoute moduleIds={[MODULE_IDS.PURCHASE_INVOICE]}>
        <ManageSinglePurchaseInvoice />
      </AuthorizedRoute>
    ),
  },
];
